import { Outlet } from "react-router-dom";
import React from "react";
import PixelScript from "./PixelScript";

const PixelScriptProviderLayout = ({ id = "", pathName = "", pathNames = [] }) => {
  const showScript = id && pathNames.includes(pathName);

  return (
    <>
      {showScript && <PixelScript id={id} />}
      <Outlet />
    </>
  );
};

export default PixelScriptProviderLayout;
